'use client';

import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { Typography, Stack } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { icons } from '@peerless/ui-assets/icons';
import { ComponentSharedAccordion } from '@peerless/data-access/strapi';
import { useId } from 'react';
import { withSectionLayout } from './SectionLayout';
import { SectionHeader } from './SectionHeader';

interface AccordionProps {
  data: ComponentSharedAccordion;
}

function AccordionBase({ data }: AccordionProps) {
  const id = useId();
  return (
    <Stack gap={4}>
      <SectionHeader {...data.sectionHeader} />
      <Stack gap={2}>
        {data.accordionItems?.map(item => {
          return (
            <Accordion key={item.id} elevation={0}>
              <AccordionSummary
                aria-controls={`panel-content-${id}-${item.id}`}
                id={`accordion-header-${id}-${item.id}`}
                expandIcon={<FontAwesomeIcon icon={icons.downArrow} />}
              >
                <Typography variant="h3" component="h3" marginBottom={0} fontWeight={400}>
                  {item.title}
                </Typography>
              </AccordionSummary>
              <AccordionDetails
                id={`panel-content-${id}-${item.id}`}
                aria-labelledby={`accordion-header-${id}-${item.id}`}
              >
                <Stack>
                  <div dangerouslySetInnerHTML={{ __html: item.htmlText }} />
                </Stack>
              </AccordionDetails>
            </Accordion>
          );
        })}
      </Stack>
    </Stack>
  );
}

export const AccordionComponent = withSectionLayout(AccordionBase);
